import type { InvoicePageTabId } from "~/modules/billing/utils/billingUtils.ts";

export type InvoicePageTabId = typeof InvoicePageTabId[keyof typeof InvoicePageTabId];

export const billingModeId = {
	periodically: "1",
	quota: "2",
} as const;

export type BillingModeId = typeof billingModeId[keyof typeof billingModeId];